import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import { routes } from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 }
	}
})

let checkOnce = true

router.beforeEach(async (to, from, next) => {
	if (
		store.getters['auth/refreshToken'] &&
		store.getters['auth/isSignIn'] &&
		checkOnce
	) {
		try {
			store.dispatch('settings/ready', false)
			checkOnce = false
			await store.dispatch('auth/refreshToken')
			setInterval(() => {
				store.dispatch('auth/refreshToken')
			}, 240000)
		} catch (err) {
			store.dispatch('auth/signOut')
		}
	}
	try {
		if (checkOnce) {
			store.dispatch('auth/signOut')
			checkOnce = false
			const promises = []
			promises.push(store.dispatch('image/init'))
			promises.push(store.dispatch('project/init'))
			await Promise.all(promises)
			store.dispatch('settings/ready', true)
		}
		if (to.matched.some((record) => record.meta.admin)) {
			store.dispatch('auth/pageAdmin', true)
			// here make validation
			if (!store.getters['auth/isSignIn']) {
				next('/login')
			}
		} else {
			store.dispatch('auth/pageAdmin', false)
		}
		next()
	} catch (err) {
		next('/404')
	}
})

export default router
